const messages = {
    'en': {
        route : {
            'home': 'home',
            'login': 'login',
            'Register': 'Register',
            'Forgot Password': 'Forgot Password',
            'Change Password': 'Change Password',
            'Password Reset': 'Password Reset',
            'History / Deposit': 'History / Deposit',
            'History / Withdraw': 'History / Withdraw',
            'History / Transfer': 'History / Transfer',
            'Promotion': 'Promotion',
            'Game': 'Game',
            'Banklist': 'BankList',
            'Addbank': 'Addbank',
            'Deposit': 'Deposit',
            'Transfer': 'Transfer',
            'Contact': 'Contact',
            'Tips': 'Tips',
            'Play': 'Play',
            'Coming Soon': 'Coming Soon',
            'Download Link' : 'Download',
            'Mini Game' : 'Mini Game',
            'Mini Game Prizes' : 'Mini Game Prizes',
            '404 Not Found': '404 Not Found'
        },
        home: {
            home: 'Home',
            games: 'Games',
            promotion: 'Promotion',
            contact: 'Contact',
            history: 'History',
            change_password: 'Change password',
            change_language: 'Change Language',
            log_out : 'Log out',
            register_success: 'Registration Success',
            welcome_message: "Welcome {username}",
            download: 'Download',
            miniGame: 'Mini Game',
            miniGamePrizes: 'Mini Game Prizes',
        },
        home_menu: {
            vip: 'VIP',
            deposit: 'Deposit',
            withdraw: 'Withdraw',
            games: 'Games',
            promotion: 'Promotion',
            download: 'Download',
            mini_game: 'Mini Game',
            register: 'Register',
            contact_us: 'Contact Us',
            how_to_play: 'How To Play',
            how_to_win: 'How To Win',
            history: 'History'
        },
        game: {
            deposit: 'Deposit',
            withdraw: 'Withdraw',
            transfer: 'Transfer',
            download: 'Download',
            website: 'Website',
            player_information: 'Player Information',
            guest_player_information_title: "Don't have an account yet ?",
            guest_player_information_desc: 'Click to link to our customer representative',
            guest_player_information_button: 'Create Account',
            pm_message: 'Contact us for create account'
        },
        user_management: {
            //login
            username: 'Username',
            password: 'Password',
            login: 'Login',
            register: 'Register',
            user_validation_rule: 'User is required',
            pass_validation_rule: 'Pass is required',
            //register
            full_name: 'Full Name',
            confirm_pass : 'Confirm Password',
            phone_no: 'Phone No',
            full_name_validation_rule: 'Full Name is required',
            full_name_length_validation_rule: 'Name is short, must be same with bank account',
            user_name_validation_rule: 'Username is required',
            user_length_validation_rule: 'Username must be more than 6 characters',
            password_validation_rule: 'Password is required',
            pass_length_validation_rule: 'Password must be more than 6 characters',
            confirm_pass_validation_rule: 'Confirm password is required',
            phone_validation_rule: 'Phone is required',
            phone_length_validation_rule: 'Phone number length is invalid',
            phone_number_validation_rule: 'Phone number is not valid',
            full_name_hint: 'Must be same with bank account for withdrawal',
            phone_number_hint: 'eg: 60163882233',
            //change password
            password_change: 'Password Change',
            old_pass: 'Old Password',
            new_pass: 'New Password',
            confirmed_pass: 'Confirmed Password',
            change: 'Change',
            back: 'Back',
            passwords_match_validation_rule: 'Password must match'
        },
        deposit: {
            title: 'deposit',
            invalid_image_type: 'Please upload the valid image format',
            not_completed_form: 'Please complete your form',
            not_any_bonus: "Don't get any bonus",
            bank_account: 'Bank Account',
            transfer_date: 'Transfer Date',
            amount: 'Amount ({currency})',
            ref_no: 'Reference Number',
            Online: 'Online',
            ATM: 'ATM',
            upload_receipt: 'Upload Receipt',
            select_promotion: 'Select Promotion',
            bank_acc_validation_rule: 'Please select one bank account',
            method_validation_rule: 'Please select method',
            require_amount_validation_rule: 'Amount is required',
            min_amount_validation_rule: 'Minimum amount: {currency} {amount}',
            submit_ticket_success: 'Submit Ticket Successfully'
        },
        withdraw: {
            title: 'withdraw',
            bank_detail: 'Bank Detail',
            bank_add_success: 'Added Successfully',
            enter_bank_detail: 'Enter Bank Detail',
            bank_name: 'Bank Name',
            account_no: 'Account No',
            account_holder_name: 'Account Holder Name',
            product_validation_rule: 'Please select a product',
            account_no_validation_rule: 'Account No is required'

        },
        transfer : {
            title: 'transfer',
            product_from: 'Product From',
            product_to: 'Product To',
            transfer_now: 'Transfer Now',
            product_transfer_from_validation_rule: 'Product Transfer From is required',
            product_transfer_same_validation_rule: 'Cannot select the same product',
            product_transfer_to_validation_rule: 'Product Transfer To is required',
        },
        history: {
            deposit_record: 'Deposit',
            withdraw_record: 'Withdraw',
            transfer_record: 'Transfer',
            deposit: 'Deposit',
            withdraw: 'Withdraw',
            transfer: 'Transfer',
            bonus: 'Bonus',
            token: 'Token',
            date_from: 'From',
            date_to: 'To',
            date: 'Date',
            amount: 'Amount',
            status: 'Status',
            detail: 'Detail',
            approved: 'Approved',
            reject: 'Reject',
            verified: 'Verified',
            processing: 'Processing',
            new: 'New',
            in: 'In',
            out: 'Out'
        },
        miniGame: {
            token: 'Token',
            credit: 'Credit',
            id: 'ID',
            game: 'Game',
            prizeName: 'Prize',
            category: 'Category',
            amount: 'Amount',
            status: 'Status',
            created_at: 'Won On',
            expiry_date: 'Expiry On',
            claimable_days: 'Claimable In',
            all: 'All',
            cash: 'Cash',
            gift: 'Gift',
            claim: 'Claim',
            unclaim: 'Unclaim',
            leftExpiryDays: 'Left {day} Days',
            expired: 'Expired',
            fromId: 'From Id',
            toId: 'To Id',
        },
        reusable: {
            ticket_id: 'Ticket ID',
            type: 'Type',
            product: 'Product',
            bank: 'Bank',
            created: 'Created',
            status: 'Status',
            remark: 'Remark',
            close: 'Close',
            lang_chinese: 'Chinese',
            lang_malay: 'Malay',
            lang_english: 'English',
            lang_thai: 'Thai',
            install_app: 'Install App',
            ios_install_app_guide_title : 'Install Guideline',
            ios_install_app_guide : 'Install App on Your Apple Device. Please tap Share and then Add to home screen'

        },
        shared: {
            copy: 'Copy',
            copied: 'Copied',
            opp_unable_copy: 'Oops, unable to copy',
            submit: 'Submit',
            reset: 'Reset',
            search: 'Search',
            guest: 'Guest',
            save: 'Save',
            enable: 'Enable',
            close: 'Close',
            warning: 'Warning',
            info: 'Info'
        },
        fcm: {
            notification: 'Notification',
            notification_request_message: "We'd like to show your the notification for the news and update",
            notification_warning_message: "Please enable notification"
        }
    },
    'zh-CN': {
        route : {
            'home': '首页',
            'login': '登入',
            'Register': '注册',
            'Forgot Password': '忘记密码',
            'Change Password': '更换密码',
            'Password Reset': '重置密码',
            'History / Deposit': '记录 / 存款',
            'History / Withdraw': '记录 / 提款',
            'History / Transfer': '记录 / 转移',
            'Promotion': '促销',
            'Game': '游戏',
            'Banklist': '银行清单',
            'Addbank': '新增银行',
            'Deposit': '存款',
            'Transfer': '转移',
            'Contact': '联络',
            'Tips': '提示',
            'Play': '玩法',
            'Coming Soon': '敬请期待',
            'Download Link' : '游戏下载',
            'Mini Game' : '迷你游戏',
            'Mini Game Prizes' : '迷你游戏奖品清单',
            '404 Not Found': '未知页面',
        },
        home: {
            home: '首页',
            games: '游戏',
            promotion: '优惠',
            contact: '联系',
            history: '记录',
            change_password: '变更密码',
            change_language: '变更语言',
            log_out : '退出',
            register_success: '注册成功',
            welcome_message: "欢迎 {username}",
            download: '下载',
            miniGame: '迷你游戏',
            miniGamePrizes: '迷你游戏奖品清单'
        },
        home_menu: {
            vip: 'VIP',
            deposit: '存款',
            withdraw: '提款',
            games: '游戏',
            promotion: '优惠',
            download: '下载',
            mini_game: '迷你游戏',
            register: '注册',
            contact_us: '联络我们',
            how_to_play: '怎么玩',
            how_to_win: '怎么赢',
            history: '交易记录'
        },
        game: {
            deposit: '存款',
            withdraw: '提款',
            transfer: '转账',
            download: '下载',
            website: '网址',
            player_information: '玩家信息',
            guest_player_information_title: '还没有帐号？',
            guest_player_information_desc: '点击链接到我们的客户端',
            guest_player_information_button: '创建账戶',
            pm_message: '联络我们创建账戶',
        },
        user_management: {
            //login
            username: '账号',
            password: '密码',
            login: '登入',
            register: '注册',
            user_validation_rule: '账号是必需的',
            pass_validation_rule: '密码是必需的',
            //register
            full_name: '全名',
            confirm_pass : '确认密码',
            phone_no: '电话号码',
            full_name_validation_rule: '全名是必需的',
            full_name_length_validation_rule: '输入的全名长度太短，必须与银行帐户名字相同',
            user_name_validation_rule: '账号是必需的',
            user_length_validation_rule: '账号必须超过6个字符',
            password_validation_rule: '密码是必需的',
            pass_length_validation_rule: '密码必须超过6个字符',
            confirm_pass_validation_rule: '确认密码是必需的',
            phone_validation_rule: '电话号码是必需的',
            phone_length_validation_rule: '输入的电话号码长度不正确',
            phone_number_validation_rule: '输入的电话号码不正确',
            full_name_hint: '必须与提款银行账户相同',
            phone_number_hint: '例如: 60163882233',
            //change password
            password_change: '密码更换',
            old_pass: '旧密码',
            new_pass: '新密码',
            confirmed_pass: '确认密码',
            change: '更改',
            back: '返回',
            passwords_match_validation_rule: '新密码和确认密码必须要相同'
        },
        deposit: {
            title: '存款',
            invalid_image_type: '请上传合适的照片格式',
            not_completed_form: '请完成以下存款表格',
            not_any_bonus: '沒有任何的优惠',
            bank_account: '银行户口',
            transfer_date: '转账日期',
            amount: '存款数额 ({currency})',
            ref_no: '参考代码',
            Online: '在线',
            ATM: 'ATM',
            upload_receipt: '上传收据',
            select_promotion: '选择优惠',
            bank_acc_validation_rule: '请选择其中一个银行户口',
            method_validation_rule: '请选择其中一种存款方式',
            require_amount_validation_rule: '请输入存款数额',
            min_amount_validation_rule: '最低的存款数额是 {currency} {amount}',
            submit_ticket_success: '成功提交'
        },
        withdraw: {
            title: '提款',
            bank_detail: '銀行资料',
            bank_add_success: '成功添加',
            enter_bank_detail: '輸入銀行资料',
            bank_name: '银行名字',
            account_no: '户口号码',
            account_holder_name: '账户持有人姓名',
            product_validation_rule: '请选择一个产品',
            account_no_validation_rule: '户口号码是必需的'
        },
        transfer : {
            title: '转账',
            product_from: '请选择要从哪个产品转移',
            product_to: '请选择要转移到哪个产品',
            transfer_now: '轉移',
            product_transfer_from_validation_rule: '选择从哪个产品转移是必需的',
            product_transfer_same_validation_rule: '不可以选择同一个产品',
            product_transfer_to_validation_rule: '选择转移到哪个产品是必需的',
        },
        history: {
            deposit_record: '存款记录',
            withdraw_record: '提款记录',
            transfer_record: '转账记录',
            deposit: '存款',
            withdraw: '提款',
            transfer: '转账',
            bonus: '优惠',
            token: '代币',
            date_from: '从(日期)',
            date_to: '到(日期)',
            date: '日期',
            amount: '数额',
            status: '状态',
            detail: '详情',
            approved: '批准',
            verified: '验证中',
            processing: '处理中',
            reject: '拒绝',
            new: '新',
            in: '汇入',
            out: '支出',
        },
        miniGame: {
            token: '游戏筹码',
            credit: '游戏积分',
            id: 'ID',
            game: '游戏',
            prizeName: '奖品',
            category: '类别',
            amount: '数额',
            status: '状态',
            created_at: '获奖日期',
            expiry_date: '到期日',
            claimable_days: '可兑换',
            all: '全部',
            cash: '现金',
            gift: '礼品',
            claim: '已兑换',
            unclaim: '尚未兑换',
            leftExpiryDays: '剩下 {day}天',
            expired: '已过期',
            fromId: '从ID',
            toId: '至ID'
        },
        reusable: {
            ticket_id: '交易码',
            type: '类型',
            product: '产品',
            bank: '银行',
            created: '创建日期',
            remark: '备注',
            close: '关闭',
            lang_chinese: '华文',
            lang_malay: '马来文',
            lang_english: '英文',
            lang_thai: '泰文',
            install_app: '安装应用程序',
            ios_install_app_guide_title : '安装指南',
            ios_install_app_guide : '在Apple设备上安装此应用程序。请点击共享，然后点击添加到主屏幕'
        },
        shared: {
            copy: '复制',
            copied: '已复制',
            opp_unable_copy: '无法复制,请稍后再尝试',
            submit: '提交',
            reset: '重置',
            search: '搜索',
            guest: '游客',
            save: '保存',
            enable: '启用',
            close: '关闭',
            warning: '提醒',
            info: '信息'
        },
        fcm: {
            notification: '通知',
            notification_request_message: "我们想向您显示最新资讯与更新",
            notification_warning_message: "请启用通知"
        }
    },
    'ms': {
        route : {
            'home': 'Utama',
            'login': 'Log Masuk',
            'Register': 'Daftar',
            'Forgot Password': 'Lupa Kata Laluan',
            'Change Password': 'Tukar Kata Laluan',
            'Password Reset': 'Reset Kata Laluan',
            'History / Deposit': 'Rekod / Deposit',
            'History / Withdraw': 'Rekod / Withdraw',
            'History / Transfer': 'Rekod / Transfer',
            'Promotion': 'Tawaran',
            'Game': 'Permainan',
            'Banklist': 'Senarai Akaun Bank',
            'Addbank': 'Tambah Akaun Bank',
            'Deposit': 'Deposit',
            'Transfer': 'Transfer',
            'Contact': 'Hubungi Kami',
            'Tips': 'Tips',
            'Play': 'Bermain',
            'Coming Soon': 'Akan Datang',
            'Download Link' : 'Muat turun',
            'Mini Game' : 'Permainan Mini',
            'Mini Game Prizes' : 'Hadiah Permainan Mini',
            '404 Not Found': '404 Tidak Dijumpai'
        },
        home: {
            home: 'Utama',
            games: 'Permainan',
            promotion: 'Promosi',
            contact: 'Hubungi Kami',
            history: 'Rekod',
            change_password: 'Tukar Kata Laluan',
            change_language: 'Tukar Bahasa',
            log_out : 'Log Keluar',
            register_success: 'Daftar Berjaya',
            welcome_message: "Selamat Datang {username}",
            download: 'Muat Turun',
            miniGame: 'Permainan Mini',
            miniGamePrizes: 'Senarai Hadiah Permainan Mini'
        },
        home_menu: {
            vip: 'VIP',
            deposit: 'Deposit',
            withdraw: 'Withdraw',
            games: 'Permainan',
            promotion: 'Promosi',
            download: 'Muat Turun',
            mini_game: 'Permainan Mini',
            register: 'Daftar',
            contact_us: 'Hubungi Kami',
            how_to_play: 'Cara Bermain',
            how_to_win: 'Cara Menang',
            history: 'Transaksi Rekod'
        },
        game: {
            deposit: 'Deposit',
            withdraw: 'Withdraw',
            transfer: 'Transfer',
            download: 'Muat Turun',
            website: 'Laman Web',
            player_information: 'Informasi Pemain',
            guest_player_information_title: 'Belum ada akaun?',
            guest_player_information_desc: 'Klik untuk pautan ke wakil pelanggan kami',
            guest_player_information_button: 'Buat akaun',
            pm_message: 'Hubungi kami untuk membuat akaun',
        },
        user_management: {
            //login
            username: 'Name Akaun',
            password: 'Kata Laluan',
            login: 'Log Masuk',
            register: 'Daftar',
            user_validation_rule: 'Name Akaun diperlukan',
            pass_validation_rule: 'Kata Laluan diperlukan',
            //register
            full_name: 'Nama Penuh',
            confirm_pass : 'Kata Laluan Pengesahan',
            phone_no: 'Nombor Telefon',
            full_name_validation_rule: 'Nama penuh diperlukan',
            full_name_length_validation_rule: 'Nama penuh tidak pendek, mestilah sama dengan akaun bank name',
            user_name_validation_rule: 'Name akaun diperlukan',
            user_length_validation_rule: 'Nama akaun mesti melebihi 6 aksara',
            password_validation_rule: 'Kata laluan diperlukan',
            pass_length_validation_rule: 'Kata laluan mesti melebihi 6 aksara',
            confirm_pass_validation_rule: 'Kata laluan pengesahan diperlukan',
            phone_validation_rule: 'Nombor telefon diperlukan',
            phone_length_validation_rule: 'Nombor telefon yang dimasukkan tidak panjang yang betul',
            phone_number_validation_rule: 'Nombor telefon yang dimasukkan tidak betul',
            full_name_hint: 'Mesti sama dengan nama pemegang akaun bank pengeluaran',
            phone_number_hint: 'Contoh: 60163882233',
            //change password
            password_change: 'Pertukaran kata laluan',
            old_pass: 'Kata laluan lama',
            new_pass: 'Kata laluan baharu',
            confirmed_pass: 'Kata laluan pengesahan',
            change: 'berubah',
            back: 'balik',
            passwords_match_validation_rule: 'Kata laluan baharu dan kata laluan pengesahan baru mestilah sama'
        },
        deposit: {
            title: 'deposit',
            invalid_image_type: 'Sila muat naik format foto yang sesuai',
            not_completed_form: 'Sila lengkapkan borang anda',
            not_any_bonus: 'Tiada tawaran',
            bank_account: 'Akaun bank',
            transfer_date: 'Tarikh pemindahan perbankan',
            amount: 'Amaun ({currency})',
            ref_no: 'No rujukan',
            Online: 'Online',
            ATM: 'ATM',
            upload_receipt: 'Muat naik resit',
            select_promotion: 'Pilih promosi',
            bank_acc_validation_rule: 'Sila pilih salah satu akaun bank',
            method_validation_rule: 'Sila pilih salah satu kaedah deposit',
            require_amount_validation_rule: 'Sila masukkan amaun',
            min_amount_validation_rule: 'Amaun terendah adalah {currency} {amount}',
            submit_ticket_success: 'Hantar berjaya'
        },
        withdraw: {
            title: 'withdraw',
            bank_detail: 'Perincian bank',
            bank_add_success: 'Tambah berjaya',
            enter_bank_detail: 'Masukkan maklumat bank',
            bank_name: 'Nama bank',
            account_no: 'Nombor akaun',
            account_holder_name: 'Nama Pemegang Akaun',
            product_validation_rule: 'Sila pilih produk',
            account_no_validation_rule: 'Nombor akaun diperlukan'
        },
        transfer : {
            title: 'transfer',
            product_from: 'Sila pilih produk yang anda hendak pindahkan daripada',
            product_to: 'Sila pilih produk yang anda hendak pindahkan ke',
            transfer_now: 'Pindah sekarang',
            product_transfer_from_validation_rule: 'Sila pilih produk yang akan dipindahkan daripada',
            product_transfer_same_validation_rule: 'Tidak boleh memilih produk yang sama',
            product_transfer_to_validation_rule: 'Sila pilih produk yang akan dipindahkan ke',
        },
        history: {
            deposit_record: 'Rekod deposit',
            withdraw_record: 'Rekod pengeluaran',
            transfer_record: 'Rekod pindahan',
            deposit: 'Deposit',
            withdraw: 'Pengeluaran',
            transfer: 'Pindahan',
            bonus: 'Bonus',
            token: 'Token',
            date_from: 'Dari Tarikh',
            date_to: 'Ke Tarikh',
            date: 'Tarikh',
            amount: 'Amaun',
            status: 'Taraf',
            detail: 'Perincian',
            approved: 'Diluluskan',
            verified: 'Mengesahkan',
            processing: 'Dalam Proses',
            reject: 'Ditolak',
            new: 'Baharu',
            in: 'Masukkan',
            out: 'Keluarkan',
        },
        miniGame: {
            token: 'token',
            credit: 'kredit',
            id: 'ID',
            game: 'Game',
            prizeName: 'Nama Hadiah',
            category: 'Kategori',
            amount: 'Amaun',
            status: 'Status',
            created_at: 'Tarikh Memenangi Hadiah',
            expiry_date: 'Tarikh Luput',
            claimable_days: 'Boleh ditebus Dalam',
            all: 'segala',
            cash: 'tunai',
            gift: 'hadiah',
            claim: 'ditebus',
            unclaim: 'belum ditebus',
            leftExpiryDays: 'tinggal {day} hari',
            expired: 'tamat tempoh',
            fromId: 'Dari ID',
            toId: 'Hingga ID'
        },
        reusable: {
            ticket_id: 'Nombor Transaksi',
            type: 'Jenis',
            product: 'Produk',
            bank: 'Bank',
            created: 'Tarikh penghantaran',
            remark: 'Remark',
            close: 'Tutup',
            lang_chinese: 'Mandarin',
            lang_malay: 'Melayu',
            lang_english: 'Inggeris',
            lang_thai: 'Thai',
            install_app: 'Pasang Aplikasi',
            ios_install_app_guide_title : 'Pasang Garis Panduan',
            ios_install_app_guide : 'Pasang Aplikasi pada Peranti Apple Anda. Sila ketik Kongsi dan kemudian Tambah ke skrin utama'
        },
        shared: {
            copy: 'Menyalin',
            copied: 'Telah menyalin',
            opp_unable_copy: 'Op, tidak boleh menyalin',
            submit: 'Hantar',
            reset: 'Menetapkan semula',
            search: 'Cari',
            guest: 'Guest',
            save: 'Simpan',
            enable: 'Aktifkan',
            close: 'Tutup',
            warning: 'Peringatan',
            info: 'Maklumat'
        },
        fcm: {
            notification: 'Notis',
            notification_request_message: "Kami ingin menunjukkan kepada anda berita dan maklumat terkini",
            notification_warning_message: "Sila aktifkan notis perkhidmatan"
        }
    },
    'th': {
        route : {
            'home': 'บ้าน',
            'login': 'เข้าสู่ระบบ',
            'Register': 'การลงทะเบียน',
            'Forgot Password': 'ลืมรหัสผ่าน',
            'Change Password': 'เปลี่ยนรหัสผ่าน',
            'Password Reset': 'รีเซ็ตรหัสผ่าน',
            'History / Deposit': 'ประวัติ / ฝาก',
            'History / Withdraw': 'ประวัติ / ถอน',
            'History / Transfer': 'ประวัติศาสตร์ / โอน',
            'Promotion': 'การส่งเสริม',
            'Game': 'เกม',
            'Banklist': 'รายชื่อธนาคาร',
            'Addbank': 'เพิ่มธนาคาร',
            'Deposit': 'เงินฝาก',
            'Transfer': 'โอน',
            'Contact': 'ติดต่อ',
            'Tips': 'เคล็ดลับ',
            'Play': 'เล่น',
            'Coming Soon': 'เร็ว ๆ นี้',
            'Download Link' : 'ดาวน์โหลด',
            'Mini Game' : 'มินิเกม',
            'Mini Game Prizes' : 'รายการรางวัลมินิเกม',
            '404 Not Found': 'ไม่พบ 404'
        },
        home: {
            home: 'บ้าน',
            games: 'เกม',
            promotion: 'การส่งเสริม',
            contact: 'ติดต่อ',
            history: 'ประวัติศาสตร์',
            change_password: 'เปลี่ยนรหัสผ่าน',
            change_language: 'เปลี่ยนภาษา',
            log_out : 'ออกจากระบบ',
            register_success: 'ลงทะเบียนสำเร็จ',
            welcome_message: "ยินดีต้อนรับ {username}",
            download: 'ดาวน์โหลด',
            miniGame: 'มินิเกม',
            miniGamePrizes: 'รายการรางวัลมินิเกม'
        },
        home_menu: {
            vip: 'VIP',
            deposit: 'เงินฝาก',
            withdraw: 'ถอน',
            games: 'เกม',
            promotion: 'การส่งเสริม',
            download: 'ดาวน์โหลด',
            mini_game: 'มินิเกม',
            register: 'การลงทะเบียน',
            contact_us: 'ติดต่อเรา',
            how_to_play: 'วิธีการเล่น',
            how_to_win: 'วิธีชนะ',
            history: 'ประวัติการทำรายการ'
        },
        game: {
            deposit: 'เงินฝาก',
            withdraw: 'ถอน',
            transfer: 'โอน',
            download: 'ดาวน์โหลด',
            website: 'เว็บไซต์',
            player_information: 'ข้อมูลผู้เล่น',
            guest_player_information_title: 'อย่ามีบัญชีหรือยัง ?',
            guest_player_information_desc: 'คลิกเพื่อเชื่อมโยงไปยังตัวแทนลูกค้าของเรา',
            guest_player_information_button: 'สร้างบัญชี',
            pm_message: 'โทรหาเราเพื่อสร้างบัญชี'
        },
        user_management: {
            //login
            username: 'ชื่อผู้ใช้',
            password: 'รหัสผ่าน',
            login: 'เข้าสู่ระบบ',
            register: 'สมัครสมาชิก',
            user_validation_rule: 'จำเป็นต้องมีผู้ใช้',
            pass_validation_rule: 'ต้องผ่าน',
            //register
            full_name: 'ชื่อเต็ม',
            confirm_pass : 'ยืนยันรหัสผ่าน',
            phone_no: 'เบอร์โทรศัพท์',
            full_name_validation_rule: 'ต้องระบุชื่อเต็ม',
            full_name_length_validation_rule: 'ชื่อสั้นต้องเป็นชื่อเดียวกันกับบัญชีธนาคาร',
            user_name_validation_rule: 'ต้องระบุชื่อผู้ใช้',
            user_length_validation_rule: 'ชื่อผู้ใช้จะต้องมากกว่า 6 ตัวอักษร',
            password_validation_rule: 'ต้องการรหัสผ่าน',
            pass_length_validation_rule: 'รหัสผ่านจะต้องมากกว่า 6 ตัวอักษร',
            confirm_pass_validation_rule: 'ต้องยืนยันรหัสผ่าน',
            phone_validation_rule: 'จำเป็นต้องใช้โทรศัพท์',
            phone_length_validation_rule: 'ความยาวหมายเลขโทรศัพท์ไม่ถูกต้อง',
            phone_number_validation_rule: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
            full_name_hint: 'ต้องเหมือนกันกับบัญชีธนาคารสำหรับการถอน',
            phone_number_hint: 'เช่น: 60163882233',
            //change password
            password_change: 'เปลี่ยนรหัสผ่าน',
            old_pass: 'รหัสผ่านเก่า',
            new_pass: 'รหัสผ่านใหม่',
            confirmed_pass: 'ยืนยันรหัสผ่าน',
            change: 'เปลี่ยนแปลง',
            back: 'กลับ',
            passwords_match_validation_rule: 'รหัสผ่านจะต้องตรงกับ'
        },
        deposit: {
            title: 'เงินฝาก',
            invalid_image_type: 'โปรดอัปโหลดรูปแบบภาพที่ถูกต้อง',
            not_completed_form: 'กรุณากรอกแบบฟอร์มของคุณ',
            not_any_bonus: "อย่าได้รับโบนัสใด ๆ",
            bank_account: 'บัญชีธนาคาร',
            transfer_date: 'วันที่โอน',
            amount: 'จำนวนเงิน ({currency})',
            ref_no: 'หมายเลขอ้างอิง',
            Online: 'ออนไลน์',
            ATM: 'เอทีเอ็ม',
            upload_receipt: 'อัพโหลดใบเสร็จรับเงิน',
            select_promotion: 'เลือกโปรโมชั่น',
            bank_acc_validation_rule: 'โปรดเลือกบัญชีธนาคารหนึ่งบัญชี',
            method_validation_rule: 'กรุณาเลือกวิธีการ',
            require_amount_validation_rule: 'จำนวนเงินที่ต้องการ',
            min_amount_validation_rule: 'จำนวนเงินขั้นต่ำ: {currency} {amount}',
            submit_ticket_success: 'ส่งตั๋วสำเร็จ'
        },
        withdraw: {
            title: 'ถอน',
            bank_detail: 'รายละเอียดธนาคาร',
            bank_add_success: 'เพิ่มสำเร็จแล้ว',
            enter_bank_detail: 'ใส่รายละเอียดธนาคาร',
            bank_name: 'ชื่อธนาคาร',
            account_no: 'เลขที่บัญชี',
            account_holder_name: 'ชื่อเจ้าของบัญชี',
            product_validation_rule: 'กรุณาเลือกผลิตภัณฑ์',
            account_no_validation_rule: 'ไม่จำเป็นต้องมีบัญชี'

        },
        transfer : {
            title: 'โอน',
            product_from: 'สินค้าจาก',
            product_to: 'ผลิตภัณฑ์ถึง',
            transfer_now: 'โอนตอนนี้',
            product_transfer_from_validation_rule: 'ต้องมีการโอนสินค้า',
            product_transfer_same_validation_rule: 'ไม่สามารถเลือกผลิตภัณฑ์เดียวกัน',
            product_transfer_to_validation_rule: 'ต้องมีการโอนสินค้า',
        },
        history: {
            deposit_record: 'เงินฝาก',
            withdraw_record: 'ถอน',
            transfer_record: 'โอน',
            deposit: 'เงินฝาก',
            withdraw: 'ถอน',
            transfer: 'โอน',
            bonus: 'โบนัส',
            token: 'เหรียญ',
            date_from: 'จาก',
            date_to: 'ไปยัง',
            date: 'วันที่',
            amount: 'จำนวน',
            status: 'สถานะ',
            detail: 'รายละเอียด',
            approved: 'ได้รับการอนุมัติ',
            reject: 'ปฏิเสธ',
            verified: 'ในการตรวจสอบ',
            processing: 'ในการประมวลผล',
            new: 'ใหม่',
            in: 'ใน',
            out: 'ออก'

        },
        miniGame: {
            token: 'โทเค็นเกม',
            credit: 'เครดิตเกม',
            id: 'ID',
            game: 'เกม',
            prizeName: 'ชื่อของขวัญ',
            category: 'หมวดหมู่',
            amount: 'จำนวน',
            status: 'สถานะ',
            created_at: 'วันที่ได้รับรางวัล',
            expiry_date: 'วันหมดอายุ',
            claimable_days: 'แลกเป็น',
            all: 'ทั้งหมด',
            cash: 'ตัวเงิน',
            gift: 'ของขวัญ',
            claim: 'แลก',
            unclaim: 'ยังไม่ได้แลก',
            leftExpiryDays: 'เหลืออีก {day} วัน',
            expired: 'ที่หมดอายุแล้ว',
            fromId: 'จากID',
            toId: 'ไปยังID'
        },
        reusable: {
            ticket_id: 'รหัสตั๋ว',
            type: 'ชนิด',
            product: 'สินค้า',
            bank: 'ธนาคาร',
            created: 'ที่สร้างไว้',
            status: 'สถานะ',
            remark: 'สังเกต',
            close: 'ปิด',
            lang_chinese: 'ชาวจีน',
            lang_malay: 'ภาษามลายู',
            lang_english: 'อังกฤษ',
            lang_thai: 'ไทย',
            install_app: 'ติดตั้งแอพ',
            ios_install_app_guide_title : 'ติดตั้งแนวทาง',
            ios_install_app_guide : 'ติดตั้งแอปบนอุปกรณ์ Apple ของคุณ กรุณาแตะแชร์จากนั้นเพิ่มไปที่หน้าจอหลัก'
        },
        shared: {
            copied: 'คัดลอก',
            opp_unable_copy: 'โอ๊ะโอไม่สามารถคัดลอกได้',
            submit: 'เสนอ',
            reset: 'รีเซ็ต',
            search: 'ค้นหา',
            guest: 'แขก',
            save: 'บันทึก',
            enable: 'เปิดใช้งานมัน',
            close: 'ปิด',
            warning: 'ข้อควรคำนึง',
            info: 'ข้อมูล'
        },
        fcm: {
            notification: 'หมายประกาศ',
            notification_request_message: "เราต้องการแสดงข่าวและข้อมูลล่าสุดให้กับคุณ",
            notification_warning_message: "กรุณาเปิดใช้งานบริการแจ้งให้ทราบล่วงหน้า"
        }
    }
};

export default messages;
